/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Dates_HintInputs */

const th_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เว้นว่างไว้หากยังไม่กำหนดวันที่`)
};

const en_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave a date empty if it is not fixed yet.`)
};

const ja_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程が未定の場合は空欄のままにしてください。`)
};

const zh_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若尚未确定，日期可留空。`)
};

const es_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja una fecha vacía si aún no está fijada.`)
};

const pt_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe a data em branco se ainda não estiver definida.`)
};

const id_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosongkan tanggal jika belum ditentukan.`)
};

const fr_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez une date vide si elle n’est pas encore fixée.`)
};

const tl_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iwanang blangko ang petsa kung wala pa itong kasiguraduhan.`)
};

const vi_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống ngày nếu chưa chốt.`)
};

const ko_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 정해지지 않았다면 날짜를 비워 두세요.`)
};

const de_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass ein Datum leer, wenn es noch nicht feststeht.`)
};

const ru_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставьте дату пустой, если она ещё не определена.`)
};

const tr_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz belli değilse tarihi boş bırakın.`)
};

const it_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia vuota la data se non è ancora stabilita.`)
};

const pl_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostaw datę pustą, jeśli nie jest jeszcze ustalona.`)
};

const uk_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Залиште дату порожньою, якщо її ще не визначено.`)
};

const hi_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगर तारीख़ अभी तय नहीं है तो खाली छोड़ दें।`)
};

const ar_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اترك التاريخ فارغًا إن لم يتحدد بعد.`)
};

const ms_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan tarikh kosong jika belum ditetapkan.`)
};

const bn_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও ঠিক না হলে তারিখ ফাঁকা রাখুন।`)
};

const zh_tw2_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若尚未確定，日期可留空。`)
};

const zh_hk2_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若尚未確定，日期可留空。`)
};

const ur_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اگر ابھی طے نہیں تو تاریخ خالی چھوڑ دیں۔`)
};

const fa_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اگر هنوز مشخص نیست تاریخ را خالی بگذارید.`)
};

const sw_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acha tarehe wazi kama bado haijapangwa.`)
};

const nl_event_dates_hint = /** @type {(inputs: Event_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat de datum leeg als die nog niet vaststaat.`)
};

/**
* | output |
* | --- |
* | "Leave a date empty if it is not fixed yet." |
*
* @param {Event_Dates_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_dates_hint = /** @type {((inputs?: Event_Dates_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Dates_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_dates_hint(inputs)
	if (locale === "ja") return ja_event_dates_hint(inputs)
	if (locale === "zh") return zh_event_dates_hint(inputs)
	if (locale === "es") return es_event_dates_hint(inputs)
	if (locale === "pt") return pt_event_dates_hint(inputs)
	if (locale === "id") return id_event_dates_hint(inputs)
	if (locale === "fr") return fr_event_dates_hint(inputs)
	if (locale === "tl") return tl_event_dates_hint(inputs)
	if (locale === "vi") return vi_event_dates_hint(inputs)
	if (locale === "ko") return ko_event_dates_hint(inputs)
	if (locale === "de") return de_event_dates_hint(inputs)
	if (locale === "ru") return ru_event_dates_hint(inputs)
	if (locale === "tr") return tr_event_dates_hint(inputs)
	if (locale === "it") return it_event_dates_hint(inputs)
	if (locale === "pl") return pl_event_dates_hint(inputs)
	if (locale === "uk") return uk_event_dates_hint(inputs)
	if (locale === "hi") return hi_event_dates_hint(inputs)
	if (locale === "ar") return ar_event_dates_hint(inputs)
	if (locale === "ms") return ms_event_dates_hint(inputs)
	if (locale === "bn") return bn_event_dates_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_event_dates_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_event_dates_hint(inputs)
	if (locale === "ur") return ur_event_dates_hint(inputs)
	if (locale === "fa") return fa_event_dates_hint(inputs)
	if (locale === "sw") return sw_event_dates_hint(inputs)
	if (locale === "nl") return nl_event_dates_hint(inputs)
	return en_event_dates_hint(inputs)
});